<div class="popup-container">
  <h2 mat-dialog-title>Select Capillary Pressure Simulation</h2>

  <mat-dialog-content>
    <div class="simulator-layout">
      <mat-expansion-panel [expanded]="true" class="pc-results">
        <mat-expansion-panel-header>
          <mat-panel-title>Select Capillary pressure simulation</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="search">
          <mat-form-field appearance="outline" class="search-by-input">
            <mat-label>Search By</mat-label>
            <mat-select [(ngModel)]="filterByOptionSelected" id="search-by-filter-select">
              @for (option of searchByOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-input-wrapper">
            <mat-label>Simulation search</mat-label>
            <input
              matInput
              [(ngModel)]="searchString"
              (ngModelChange)="onSearchStringChange()"
            />
            @if (searchString) {
              <button mat-icon-button matSuffix (click)="onClearSearch()" aria-label="Clear">
                <mat-icon class="clear-icon">close</mat-icon>
              </button>
            }
          </mat-form-field>
          <button color="primary" class="btn btn-primary btn-big search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
            <span>Search</span>
          </button>
          <button mat-flat-button color="secondary" class="filter-btn" (click)="openAdvancedFiltersPopup()">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>

        @if (isLoadingTable) {
          <div class="spinner-container">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        } @else {
          <div class="scroll-x">
            <table mat-table [dataSource]="dataSource" matSort class="custom-table results-table">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>Select simulation</th>
                <td mat-cell *matCellDef="let element">
                  <mat-radio-button
                    [value]="element.simulationId"
                    [disabled]="!isRunResultValid(element)"
                    [checked]="selectedRun?.runId === element.runId"
                    (change)="onPcSimulationSelectionChange(element)"
                  ></mat-radio-button>
                </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <ng-container matColumnDef="fileName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rock file</th>
                <td mat-cell *matCellDef="let element">{{ element.fileName | removeExtension }}</td>
              </ng-container>

              <ng-container matColumnDef="direction">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Direction</th>
                <td mat-cell *matCellDef="let element">{{ element.direction | uppercase }}</td>
              </ng-container>

              <ng-container matColumnDef="cycle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cycle</th>
                <td mat-cell *matCellDef="let element">{{ getCyclesForRun(element) }}</td>
              </ng-container>

              <ng-container matColumnDef="interfactialTension">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Interfacial tension (N/m)</th>
                <td mat-cell *matCellDef="let element">{{ element.parameters.interfactialTension | number: '1.0-3' }}</td>
              </ng-container>

              <ng-container matColumnDef="contactAnglePrimaryDrainage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary drainage cosine</th>
                <td mat-cell *matCellDef="let element">{{ element.parameters.contactAnglePrimaryDrainage | number: '1.0-3' }}</td>
              </ng-container>

              <ng-container matColumnDef="contactAngleFirstImbibition">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First imbibition cosine</th>
                <td mat-cell *matCellDef="let element">{{ element.parameters.contactAngleFirstImbibition != null ? (element.parameters.contactAngleFirstImbibition | number: '1.0-3') : '—' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <tr class="mat-row table-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                  No data matching the filter value
                </td>
              </tr>
            </table>
          </div>
        }
        <mat-paginator
          class="mat-paginator"
          [length]="totalCount"
          [pageIndex]="currentPage"
          [pageSize]="currentPageSize"
          [pageSizeOptions]="[5, 10, 20, 30]"
          aria-label="Select page"
        ></mat-paginator>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" class="kr-config">
        <mat-expansion-panel-header>
          <mat-panel-title>Capillary Pressure simulation</mat-panel-title>
        </mat-expansion-panel-header>

        @if (selectedSimulation) {
          <div class="kr-input">
            <div class="kr-input-column">
              <div class="chart-container">
                <highcharts-chart
                  style="width: 100%; height: 550px; display: block; border: 1px solid var(--main_borderColor)"
                  [Highcharts]="Highcharts"
                  [options]="chartOptions"
                  (chartInstance)="saveChartInstance($event)"
                ></highcharts-chart>
              </div>
            </div>

            <div class="kr-input-column">
              <form [formGroup]="cyclesForm">
                <div class="input-row">
                  <span>Cycles</span>
                  <div class="direction-options">
                    <mat-checkbox formControlName="d1">PD</mat-checkbox>
                    <mat-checkbox formControlName="imb">FI</mat-checkbox>
                    <mat-checkbox formControlName="d2">SD</mat-checkbox>
                  </div>
                </div>
              </form>
            </div>
          </div>
        } @else {
          <div class="no-results">
            <mat-icon class="no-results-icon">info</mat-icon>
            <p>Please select Capillary Pressure simulation.</p>
          </div>
        }
      </mat-expansion-panel>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="!selectedRun || !selectedSimulation"
    >
      Confirm
    </button>
  </mat-dialog-actions>
</div>
